import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  GroupWork as GroupWorkIcon,
  LibraryBooks as MultipleIcon,
  Description as SingleIcon,
  LockOpen as LockOpenIcon,
  Lock as LockIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import type { QuickFilterConfig, AdvancedSectionDefinition } from 'ml-react-component-library';

import type { IGridFilterConfig } from '@/apps/engagement-letter-database/data/types';

export const ENGAGEMENT_FILTER_CONFIG: IGridFilterConfig = {
  dateFields: ['openDate', 'closedDate'],
  booleanFields: ['isExecuted'],
  quickFilterFields: ['clientName', 'clientNumber', 'responsibleAttorney', 'practiceGroup'],
};

export const WAIVER_FILTER_CONFIG: IGridFilterConfig = {
  dateFields: ['adverseLetterDate', 'clientLetterDate'],
  booleanFields: [],
  quickFilterFields: [
    'clientName',
    'matterNumber',
    'clientNumber',
    'adverseClientName',
    'adverseContactSigner',
    'adverseAttorney',
    'clientContact',
    'clientAttorney',
  ],
};

export const RELATED_CLIENT_FILTER_CONFIG: IGridFilterConfig = {
  dateFields: [],
  booleanFields: [],
  quickFilterFields: ['relatedClientName', 'relatedClientNumber', 'clients', 'clientCount'],
};

// Quick-filter buttons rendered in the grid's filter bar.
export const ENGAGEMENT_QUICK_FILTERS: QuickFilterConfig[] = [
  { key: 'executed', label: 'Is Executed', icon: <CheckCircleIcon />, color: 'secondary', activeColor: 'success' },
  { key: 'notExecuted', label: 'Not Executed', icon: <CancelIcon />, color: 'secondary', activeColor: 'error' },
  { key: 'open', label: 'Open', icon: <LockOpenIcon />, color: 'secondary', activeColor: 'success' },
  { key: 'closed', label: 'Closed', icon: <LockIcon />, color: 'secondary', activeColor: 'warning' },
];

export const WAIVER_QUICK_FILTERS: QuickFilterConfig[] = [
  { key: 'multipleWaivers', label: 'Multiple Waivers', icon: <MultipleIcon />, activeColor: 'info' },
  { key: 'singleWaiver', label: 'Single Waiver', icon: <SingleIcon />, activeColor: 'primary' },
];

export const RELATED_CLIENT_QUICK_FILTERS: QuickFilterConfig[] = [
  { key: 'multipleClients', label: 'Multiple Clients', icon: <GroupWorkIcon />, activeColor: 'info' },
  { key: 'singleClient', label: 'Single Client', icon: <PersonIcon />, activeColor: 'primary' },
];

// Advanced filter schema rendered in the grid's "Advanced" panel.
export const ENGAGEMENT_ADVANCED_SECTIONS: AdvancedSectionDefinition[] = [
  {
    key: 'client',
    title: 'Client Details',
    fields: [
      {
        id: 'clientName',
        label: 'Client Name',
        size: { xs: 12, md: 6 },
        control: { type: 'text', placeholder: 'Search by client name...', clearable: true },
      },
      {
        id: 'clientNumber',
        label: 'Client Number',
        size: { xs: 12, md: 6 },
        control: { type: 'text', placeholder: 'Search by client number...', clearable: true },
      },
      {
        id: 'openDate',
        label: 'Client Open Date',
        size: { xs: 12, md: 6 },
        control: { type: 'dateRange', fromLabel: 'From', toLabel: 'To' },
      },
      {
        id: 'closedDate',
        label: 'Client Closed Date',
        size: { xs: 12, md: 6 },
        control: { type: 'dateRange', fromLabel: 'From', toLabel: 'To' },
      },
    ],
  },
];

export const WAIVER_ADVANCED_SECTIONS: AdvancedSectionDefinition[] = [
  {
    key: 'client',
    title: 'Client & Matter',
    fields: [
      {
        id: 'clientName',
        label: 'Client Name',
        size: { xs: 12, md: 4 },
        control: { type: 'text', placeholder: 'Search by client name...', clearable: true },
      },
      {
        id: 'clientNumber',
        label: 'Client Number',
        size: { xs: 12, md: 4 },
        control: { type: 'text', placeholder: 'CLT-2024-001', clearable: true },
      },
      {
        id: 'matterNumber',
        label: 'Matter Number',
        size: { xs: 12, md: 4 },
        control: { type: 'text', placeholder: 'Search by matter number...', clearable: true },
      },
      {
        id: 'adverseClient',
        label: 'Adverse Client',
        size: { xs: 12, md: 6 },
        control: { type: 'text', placeholder: 'Search by adverse client...', clearable: true },
      },
      {
        id: 'adverseAttorney',
        label: 'Adverse MLB Attorney',
        size: { xs: 12, md: 6 },
        control: { type: 'text', placeholder: 'Search by adverse attorney...', clearable: true },
      },
    ],
  },
];

export const RELATED_CLIENT_ADVANCED_SECTIONS: AdvancedSectionDefinition[] = [
  {
    key: 'relatedClient',
    title: 'Related Client Details',
    fields: [
      {
        id: 'relatedClientName',
        label: 'Related Client Name',
        size: { xs: 12, md: 4 },
        control: { type: 'text', placeholder: 'Search by related client name...', clearable: true },
      },
      {
        id: 'relatedClientNumber',
        label: 'Related Client Number',
        size: { xs: 12, md: 4 },
        control: { type: 'text', placeholder: 'Search by related client number...', clearable: true },
      },
      {
        id: 'memberClient',
        label: 'Member Client',
        size: { xs: 12, md: 4 },
        control: { type: 'text', placeholder: 'Search member client name or number...', clearable: true },
      },
    ],
  },
];
